import { callNative } from '@ifit/native-webview-interface';
import { PayloadObject } from '@ifit/native-webview-interface/out/Payload';
import { Entity, Screen, startPositiveEngagement } from '@ifit/put-a-ring-on-it';

export interface IUrlNavigationInstruction extends PayloadObject {
  methodName: 'NavigateToPath';
  path: string;
}

export interface ISeriesNavigationInstruction extends PayloadObject {
  methodName: 'StartProgram';
  programId: string;
}

export interface IWorkoutNavigationInstruction extends PayloadObject {
  methodName: 'StartWorkout';
  workoutId: string;
}

export type NavigationInstruction =
  | IUrlNavigationInstruction
  | ISeriesNavigationInstruction
  | IWorkoutNavigationInstruction;

export function getUrlNavigationInstruction(url: string): NavigationInstruction {
  if (url.startsWith('https://www.ifit.com/programDetails/')) {
    return {
      methodName: 'StartProgram',
      programId: url.replace('https://www.ifit.com/programDetails/', ''),
    };
  }

  if (url.startsWith('https://www.ifit.com/workout/')) {
    return {
      methodName: 'StartWorkout',
      workoutId: url.replace('https://www.ifit.com/workout/', ''),
    };
  }

  return {
    methodName: 'NavigateToPath',
    path: url,
  };
}

export enum ROWTITLES {
  FEATURED_ITEM = 'Featured now',
  FAVORITES = 'Favorites',
  QUICK_FIND_ITEM = 'Browse by category',
  LIVE_WORKOUT_ITEM = 'Live Workouts',
  PARAMOUNT_ITEM = 'Paramount',
  UP_NEXT_ITEM = 'Up next for you',
  MARKETING_ITEM = 'The latest from iFIT',
  RECOMMENDED_SERIES_ITEM = 'Recommended series',
  RECOMMENDED_WORKOUTS_ITEM = 'Recommended workouts',
  MATRIX_COMMERCIAL_WORKOUTS = 'Matrix commercial workouts',
  CHALLENGES_WORKOUTS = 'Challenge workouts',
}

export function getUserNavigationHandler(url: string, rowTitle: ROWTITLES = undefined): () => void {
  return () => {
    const navigationInstruction = getUrlNavigationInstruction(url);
    trackUserEngagement(navigationInstruction, rowTitle);
    callNative(navigationInstruction);
  };
}

function trackUserEngagement(navigationInstruction: NavigationInstruction, rowTitle: string): void {
  if (navigationInstruction.methodName !== 'NavigateToPath') {
    const entityType = navigationInstruction.methodName === 'StartWorkout' ? Entity.Workout : Entity.Series;
    const id = entityType === Entity.Workout ? navigationInstruction.workoutId : navigationInstruction.programId;
    startPositiveEngagement({
      screen: Screen.Home,
      entity: entityType,
      id,
      page: '/',
      rowTitle,
    });
  }
}

export function logout(): void {
  callNative({
    methodName: 'RunBehavior',
    key: 'Logout',
  });
}
